/** sessionStorage mirror of the consent request id — survives login redirects that drop the hash query. */
export const OAUTH_CONSENT_REQUEST_ID_KEY = "oauthConsentRequestId";
/** The request a forced login was already attempted for — a second freshLoginRequired for it means the IdP could not prove freshness. */
export const OAUTH_CONSENT_FORCED_LOGIN_REQUEST_ID_KEY =
  "oauthConsentForcedLoginRequestId";
